"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROICalculatorSlider = void 0;
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var ROICalculatorUtils_1 = require("./ROICalculatorUtils");
var ROICalculatorSlider = (function (_super) {
    __extends(ROICalculatorSlider, _super);
    function ROICalculatorSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.uncommittedValue = null;
        _this.handleTextInputChange = function (str) {
            if (!!str) {
                _this.uncommittedValue = parseInt(str);
            }
            else {
                _this.uncommittedValue = 0;
            }
        };
        _this.handleTextInputBlur = function () {
            if (_this.uncommittedValue !== null) {
                _this.handleValueChange(_this.uncommittedValue);
            }
        };
        _this.handleRangeChange = function (event) {
            var parsed = parseInt(event.target.value);
            _this.uncommittedValue = parsed;
            _this.handleValueChange(parsed);
        };
        _this.handleKeyDown = function (event) {
            switch (event.key) {
                case kaleidoscope_1.KeyType.ArrowUp:
                case kaleidoscope_1.KeyType.ArrowRight: {
                    _this.handleValueChange(_this.props.value + _this.props.increment);
                    break;
                }
                case kaleidoscope_1.KeyType.ArrowDown:
                case kaleidoscope_1.KeyType.ArrowLeft: {
                    _this.handleValueChange(_this.props.value - _this.props.increment);
                    break;
                }
            }
        };
        _this.handleValueChange = function (x) {
            var _a = _this.props, increment = _a.increment, min = _a.min, max = _a.max;
            var value = (0, ROICalculatorUtils_1.calculateRoiSliderValue)(x, min, max, increment);
            _this.props.onValueChange(value);
            _this.uncommittedValue = null;
        };
        return _this;
    }
    ROICalculatorSlider.prototype.render = function () {
        var _a = this.props, min = _a.min, max = _a.max, label = _a.label, useStaticRangeInput = _a.useStaticRangeInput, widgetId = _a.widgetId;
        return (react_1.default.createElement("div", { className: "roi-calculator-slider" },
            react_1.default.createElement("div", { className: "roi-calculator-slider__header" },
                react_1.default.createElement("div", { className: "roi-calculator-slider__label-container" },
                    react_1.default.createElement("label", { className: "roi-calculator-slider__label" }, label)),
                react_1.default.createElement("div", { "data-qwilr-widgetid": widgetId, "data-qwilr-component": "roi-calculator-text-input", className: "roi-calculator-slider__text-input" },
                    react_1.default.createElement(kaleidoscope_1.TextInput, { label: label, size: kaleidoscope_1.TextInputSize.XSmall, variant: kaleidoscope_1.TextInputVariant.Underlined, type: kaleidoscope_1.TextInputType.Number, onChange: this.handleTextInputChange, onBlur: this.handleTextInputBlur, value: "".concat(this.sliderValue) }))),
            useStaticRangeInput ? (react_1.default.createElement("div", { className: "roi-calculator-slider__static-range", style: {
                    "--slider-progress": this.sliderProgressPercentage,
                } },
                react_1.default.createElement("div", { className: "track" },
                    react_1.default.createElement("div", { className: "track-filled" }),
                    react_1.default.createElement("div", { className: "track-unfilled" })),
                react_1.default.createElement("div", { className: "thumb-container" },
                    react_1.default.createElement("div", { className: "thumb" })))) : (react_1.default.createElement("input", { type: "range", min: min, max: max, value: "".concat(this.sliderValue), onChange: this.handleRangeChange, onKeyDown: this.handleKeyDown, role: "slider", "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": this.sliderValue, "data-qwilr-widgetid": widgetId, "data-qwilr-component": "roi-calculator-slider", className: "roi-calculator-slider__range-input", style: { "--slider-progress": this.sliderProgressPercentage } }))));
    };
    Object.defineProperty(ROICalculatorSlider.prototype, "sliderValue", {
        get: function () {
            if (this.uncommittedValue === null) {
                var _a = this.props, value = _a.value, min = _a.min, max = _a.max;
                return (0, lodash_1.clamp)(value, min, max);
            }
            return this.uncommittedValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ROICalculatorSlider.prototype, "sliderProgressPercentage", {
        get: function () {
            var _a = this.props, min = _a.min, max = _a.max;
            return "".concat(((this.sliderValue - min) / (max - min)) * 100, "%");
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], ROICalculatorSlider.prototype, "uncommittedValue", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorSlider.prototype, "handleTextInputChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorSlider.prototype, "handleRangeChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROICalculatorSlider.prototype, "handleValueChange", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROICalculatorSlider.prototype, "sliderValue", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ROICalculatorSlider.prototype, "sliderProgressPercentage", null);
    ROICalculatorSlider = __decorate([
        mobx_react_1.observer
    ], ROICalculatorSlider);
    return ROICalculatorSlider;
}(react_1.default.Component));
exports.ROICalculatorSlider = ROICalculatorSlider;
